/* Copyright (c) 2020-present CloudIO Inc */

import React, { Suspense, lazy } from 'react';

const MarkdownLazy = lazy(
  () => import(/* webpackChunkName: "markdown" */ './MarkdownLazy'),
);

export default function Markdown({
  children,
}: {
  children: string;
}): React.ReactElement {
  return (
    <Suspense fallback={<div>Loading Markdown...</div>}>
      <MarkdownLazy>{children}</MarkdownLazy>
    </Suspense>
  );
}
